import Setting from "../../setting.js";
import StrategicSurveyTable from "@/components/StrategicSurveyTable.vue";
import ExcelExport from "@/components/ExcelExport.vue";
import { useAppStore } from "../stores/main";

export default {
  name: "StrategicSurveyForm",

  components: {
    StrategicSurveyTable,
    ExcelExport,
  },
  data: () => ({
    store: useAppStore(),
    loading: false,
    items: [],
    exportItems: [],

    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },

      {
        text: "Strategic Survey Form",
        disabled: false,
      },
    ],
    headers: [
      {
        text: "Actions",
        align: "start",
        sortable: false,
        value: "actions",
      },
      {
        text: "Id",
        align: "start",
        sortable: true,
        value: "id",
      },
      {
        text: "Your company/organisation name",
        align: "start",
        sortable: true,
        value: "data.organizationName",
      },
      {
        text: "Create Date",
        align: "end",
        sortable: true,
        value: "createdDate",
      },
      {
        text: "Q1 Importance",
        align: "end",
        sortable: true,
        value: "data.q1_Importance",
      },
      {
        text: "Q1 Comment",
        align: "end",
        sortable: false,
        value: "data.q1_Comment",
      },
      {
        text: "Q2 Impact",
        align: "end",
        sortable: true,
        value: "data.q2_Impact",
      },
      {
        text: "Q2 Comment",
        align: "end",
        sortable: false,
        value: "data.q2_Comment",
      },
      {
        text: "Q3 Competitiveness",
        align: "end",
        sortable: true,
        value: "data.q3_Competitiveness",
      },
      {
        text: "Q3 Comment",
        align: "end",
        sortable: false,
        value: "data.q3_Comment",
      },
      {
        text: "Q4 Cost",
        align: "end",
        sortable: true,
        value: "data.q4_Cost",
      },
      {
        text: "Q4 Comment",
        align: "end",
        sortable: false,
        value: "data.q4_Comment",
      },
      {
        text: "Q5 Performance",
        align: "end",
        sortable: true,
        value: "data.q5_Performance",
      },
      {
        text: "Q5 Comment",
        align: "end",
        sortable: false,
        value: "data.q5_Comment",
      },
      {
        text: "Q6 Market",
        align: "end",
        sortable: true,
        value: "data.q6_Market",
      },
      {
        text: "Q6 Comment",
        align: "end",
        sortable: false,
        value: "data.q6_Comment",
      },
      {
        text: "Q7 Security",
        align: "end",
        sortable: true,
        value: "data.q7_Security",
      },
      {
        text: "Q7 Comment",
        align: "end",
        sortable: false,
        value: "data.q7_Comment",
      },

      {
        text: "Q8 Integration",
        align: "end",
        sortable: true,
        value: "data.q8_Integration",
      },
      {
        text: "Q8 Comment",
        align: "end",
        sortable: false,
        value: "data.q8_Comment",
      },
      {
        text: "Q9 Governance",
        align: "end",
        sortable: true,
        value: "data.q9_Governance",
      },
      {
        text: "Q9 Comment",
        align: "end",
        sortable: false,
        value: "data.q9_Comment",
      },

      {
        text: "Q10 Standardization",
        align: "end",
        sortable: true,
        value: "data.q10_Standardization",
      },
      {
        text: "Q10 Comment",
        align: "end",
        sortable: false,
        value: "data.q10_Comment",
      },
    ],
    fields: {
      Id: "Id",
      "Your company/organisation name": "organizationName",
      "Create Date": "createdDate",
      "Q1 Importance": "q1_Importance",
      "Q1 Comment": "q1_Comment",
      "Q2 Impact": "q2_Impact",
      "Q2 Comment": "q2_Comment",
      "Q3 Competitiveness": "q3_Competitiveness",
      "Q3 Comment": "q3_Comment",
      "Q4 Cost": "q4_Cost",
      "Q4 Comment": "q4_Comment",
      "Q5 Performance": "q5_Performance",
      "Q5 Comment": "q5_Comment",
      "Q6 Market": "q6_Market",
      "Q6 Comment": "q6_Comment",
      "Q7 Security": "q7_Security",
      "Q7 Comment": "q7_Comment",
      "Q8 Integration": "q8_Integration",
      "Q8 Comment": "q8_Comment",
      "Q9 Governance": "q9_Governance",
      "Q9 Comment": "q9_Comment",
      "Q10 Standardization": "q10_Standardization",
      "Q10 Comment": "q10_Comment",
    },
  }),
  async mounted() {
    if (!this.store.getAuth) {
      this.$router.push("/");
    }
  },
  async created() {
    this.loading = true;
    const result = await this.getData();

    this.items = result.data.items;

    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];

      /*
      console.warn({
        item: item,
      });
      */

      this.exportItems.push({
        Id: item.id,
        organizationName: item.data.organizationName,
        createdDate: item.createdDate,
        q1_Importance: item.data.q1_Importance,
        q1_Comment: item.data.q1_Comment,
        q2_Impact: item.data.q2_Impact,
        q2_Comment: item.data.q2_Comment,
        q3_Competitiveness: item.data.q3_Competitiveness,
        q3_Comment: item.data.q3_Comment,
        q4_Cost: item.data.q4_Cost,
        q4_Comment: item.data.q4_Comment,
        q5_Performance: item.data.q5_Performance,
        q5_Comment: item.data.q5_Comment,
        q6_Market: item.data.q6_Market,
        q6_Comment: item.data.q6_Comment,
        q7_Security: item.data.q7_Security,
        q7_Comment: item.data.q7_Comment,
        q8_Integration: item.data.q8_Integration,
        q8_Comment: item.data.q8_Comment,
        q9_Governance: item.data.q9_Governance,
        q9_Comment: item.data.q9_Comment,
        q10_Standardization: item.data.q10_Standardization,
        q10_Comment: item.data.q10_Comment,
      });
    }
    /*
    console.warn({
      items: this.items,
      exportItems: this.exportItems,
    });
    */

    this.loading = false;
  },
  methods: {
    onBreadClick(event) {
      if (event.href) this.$router.push(event.href);
    },
    async getData() {
      return await this.axios.get(
        Setting[process.env.NODE_ENV].API + "StrategicSurveyForm/GetAll",

        {
          headers: {
            "Access-Control-Allow-Origin": Setting[process.env.NODE_ENV].Source,
          },
        }
      );
    },
  },
};
